document.addEventListener("DOMContentLoaded", function () {
  const productForm = document.querySelector(".product-form");

  if (!productForm) {
    return;
  }

  const targetClass = "below-view";
  const bodyClass = "sticky-product-form";
  const footerClass = "reached-footer";

  let observer;
  /** @type {ResizeObserver} */
  let resizeObserver;
  let footerObserver;

  const handleIntersect = (entries) => {
    const targetElement = document.querySelector(".product-form");
    entries.forEach((entry) => {
      if (!entry.isIntersecting && entry.boundingClientRect.top < 0) {
        targetElement.classList.add(targetClass);
        targetElement.classList.add(targetClass);
        document.body.classList.add(bodyClass);
      } else {
        targetElement.classList.remove(targetClass);
        document.body.classList.remove(bodyClass);
      }
    });
  };

  const handleFooterIntersect = (entries) => {
    const targetElement = document.querySelector(".product-form");
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        targetElement.classList.add(footerClass);
      } else {
        targetElement.classList.remove(footerClass);
      }
    });
  };

  /** @type {ResizeObserverCallback} */
  const handleResize = (entries) => {
    for (let entry of entries) {
      document.body.style.setProperty(
        "--sticky-product-form-height",
        entry.borderBoxSize[0].blockSize,
      );
    }
  };

  const setupObserver = () => {
    const sentinelElement = document.createElement("div");
    sentinelElement.classList.add("sentinel-element");
    sentinelElement.style.display = "block";
    productForm.insertAdjacentElement("afterend", sentinelElement);

    observer = new IntersectionObserver(handleIntersect, {
      threshold: 0,
    });
    observer.observe(sentinelElement);

    const targetElement = document.querySelector(".product-form");
    resizeObserver = new ResizeObserver(handleResize);
    resizeObserver.observe(targetElement, { box: "border-box" });

    // Setup footer detection
    const footer = document.querySelector("footer.footer");
    if (footer) {
      footerObserver = new IntersectionObserver(handleFooterIntersect, {
        threshold: 0,
        rootMargin: "0px 0px -50px 0px", // Trigger when footer is 50px from viewport bottom
      });
      footerObserver.observe(footer);
    }
  };

  setupObserver();
});
